import {DomainStore} from 'shared/store';
import {t, api} from 'shared/core';
import {endpoints, types} from 'main/tools';
import { makeAutoObservable } from 'mobx';
import _ from 'lodash';
import {successAlert} from 'shared/tools';
import {TimeOffType} from 'main/stores/time_off';

class TypesState {
  store = new DomainStore();

  timeOffTypes;
  editingType = {};
  editTypeModalOpen = false;
  reorderTypesModalOpen = false;
  errors = {};
  reorderingTypes;
  editMessage = 'time_off.types.Add Type';
  originalUnit;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.TIME_OFF.TYPES.ALL
    ]);

    this.timeOffTypes = this.store._getAll(types.TIME_OFF.TYPE, TimeOffType);
  }

  openEditTypeModal(type) {
    this.editTypeModalOpen = true;
    this.editingType = new TimeOffType(type);
    this.originalUnit = type.unit;
  }

  addType() {
    this.editMessage = 'time_off.types.Add Type';
    this.openEditTypeModal(new TimeOffType());
  }

  closeEditTypeModal() {
    this.editTypeModalOpen = false;
    this.errors = {};
  }

  editType(type) {
    this.editMessage = 'time_off.types.Edit Type';
    this.openEditTypeModal(type);
  }

  async saveType() {
    const {model, errors} = await (this.editingType.isNew ?
      this.store.post(endpoints.TIME_OFF.TYPES.ALL, types.TIME_OFF.TYPE, this.editingType) :
      this.store.patch(this.editingType));

    this.errors = errors;

    if (model) {
      await this.load();
      this.closeEditTypeModal();
      successAlert(t('time_off.types.Time off type added.'));
    }
  }

  async destroyType(type) {
    await this.store.destroy(type);
    await this.load();
  }

  openReorderTypesModal() {
    this.reorderingTypes = this.timeOffTypes.map(type => new TimeOffType(type));
    this.reorderTypesModalOpen = true;
  }

  closeReorderTypesModal() {
    this.reorderTypesModalOpen = false;
  }

  async saveOrders() {
    var typesParams = {};
    this.reorderingTypes.forEach(type => typesParams[type['id']] = type['order']);

    await api.patch(endpoints.TIME_OFF.TYPES.REORDER, typesParams);

    await this.load();
    this.closeReorderTypesModal();
  }

  get orderedTypes() {
    return _.sortBy(this.timeOffTypes, ['order']);
  }
}

export default TypesState;
